import { MessageContentProps } from './types';

export const MessageContent = ({ ownMessage, children }: MessageContentProps) => (
    <div
        className={`relative max-w-[30em] min-w-0 inline-block rounded-b-lg text-sm wrap-break-word pt-1 pb-2 px-3 ${
            ownMessage ? 'bg-chat-own-msg rounded-ss-lg ms-2 last:ms-10 mr-4 before:-inset-e-3 before:-scale-x-100' : 'bg-gray-200 rounded-se-lg ms-4 me-2 last:me-10 before:-inset-s-3'
        } chat-tail before:absolute before:top-0 before:size-3.5 before:bg-inherit`}
    >
        {children}
    </div>
);
